export const colors = {
    lighten: '#F6FFFD',
    default: '#14777B',
    default2: '#21A5AA',
    defaultTemporalComparation: '#93D7DC',
    defaultShadow: '0px 10px 32px rgba(20, 119, 123, 0.24)',
    defaultHover: '#09585B',
    grey000: '#FFFFFF',
    grey100: '#0F172A',
    grey200: '#334155',
    grey300: '#64748B',
    grey400: '#94A3B8',
    grey450: '#EFEFEF',
    grey500: '#CBD5E1',
    grey600: '#E2E8F0',
    grey700: '#F1F5F9',
    grey800: '#F8FAFC',
    grey900: '#787878',
    grey1000: '#A1A1A1',
    grey1100: '#BBBBBB',
    grey1200: '#F5F5F5',
    grey1300: '#334155',
    grey1400: '#F5F5F5',
    grey1500: '#9e9fa0',
    alertDanger: '#FF4338',
    alertWarning: '#F97316',
    alertSuccess: '#22C55E',
    alertInfo: '#0060F9',
    black000: '#1E293B',
    blue000: '#3B82F6',
    defaultRGBA: 'rgba(33, 165, 170, 0.24)',
    blue000RGBA: 'rgba(59, 130, 246, 0.24)',
    dateRangeDefault: 'rgba(95, 187, 190, 1)',
    defaultDisabled: '#CEE2E4',
    defaultDarker: '#034446',
    greyDisabled: '#8C8C8C',
    specificTableBackground: '#E4EBEB',
    greyPlaceholder: '#94A3B8',
};

export default colors;

export const donutBackgroundColor = [
    '#22C55E',
    '#0060F9',
    '#FF4338',
    '#F97316',
    '#64748B',
    '#FAD55C',
    '#4C24CE',
    '#22D3EE',
    '#E879f9',
    '#f472b6',
    '#6366f1',
];

export const colorScales = {
    shade1: [colors.default, '#5FBBBE', '#F9BB5D', '#EC6564'],
    shade2: [colors.blue000, '#4D92FF', '#9EC3FF', '#C8DDFF'],
    monoChrome1: Array(4).fill(colors.blue000),
};

export const quantilesColorScale = {
    shade1: ['#22C55E', '#D3CB13', '#F97316', '#FF4338'],
};
